export { renderAccordionItem_unstable as renderAccordionItem } from '@fluentui/react-accordion';
